import * as c from '@iamo/custody-lib';
import { IConnection } from './Connection';

export enum EnumCoinName {
    ETHEREUM = 'ETHEREUM',
    DOLLAR = 'DOLLAR',
    EURO = 'EURO',
}

export interface IExchangeCoin {
    from: string;
    to: string;
    amount: string;
    total: string;
}

/**
 * The rates-class of the wallet
 */
export class Rates {

    // The blockchain property of the backend connection object.
    connection: IConnection

    /**
     * initializes the class
     * @param connection The backend connection object.
     */
    constructor(connection: IConnection){
        this.connection = connection
    }

    /**
     * Exchanges an amount from one coin to another
     * @param amount The amount to be exchanged
     * @param from The from coin enum
     * @param to The to coin enum
     * @param all get all from available APIs
     * @returns Return of exchange api as list of results.
     */
    exchange(
        amount: number,
        from: EnumCoinName,
        to: EnumCoinName,
        all: boolean = false
    ): Promise<IExchangeCoin[]> {
        return c.Rates.exchange(this.connection, amount, from, to, all)
    } 

}

export default Rates